import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { finalize, tap } from 'rxjs/operators';
import { UserDatasetIssueType, UserDatasetService, UserDatasetValidationResultDto, UserDatasetValidationResultPartDto, UserDatasetValidationResultType } from 'src/app/services/api.services';
import { catchAppError } from 'src/app/shared/utils';

@Component({
  templateUrl: 'userdataset-validation-state.dialog.html',
  standalone: false
})
export class UserDatasetValidationStateDialog {
  loading = true;
  result?: UserDatasetValidationResultDto;
  canSeeDetails = false;
  detailsExpanded = false;
  details: string[] = [];

  constructor(
    public dialogRef: MatDialogRef<UserDatasetValidationStateDialog>,
    private userDatasetService: UserDatasetService,
    @Inject(MAT_DIALOG_DATA) public data: UserDatasetValidationStateDialogData) {
    this.userDatasetService.getValidateState(this.data.userDatasetId).pipe(
      tap((state) => {
        this.result = state.result;
        this.canSeeDetails = this.data.canSeeDetails && state.result.type != UserDatasetValidationResultType.Valid;

        if (this.canSeeDetails) {
          state.result.parts.forEach((p, datasetIndex) => {
            this.addDetails(p);
          });

          if (!this.details.length) {
            this.canSeeDetails = false;
          }
        }
      }),
      catchAppError(),
      finalize(() => this.loading = false)
    ).subscribe();
  }

  private addDetails(part: UserDatasetValidationResultPartDto) {
    // INFO: Currently only handling details for IN-3423, i.e. let user know about missing ids
    let missingRequiredInputNames: string[] = [];

    Object.entries(part.inputs).forEach(([id, issues]) => {
      let issue = issues.find(x => x.type === UserDatasetIssueType.MissingRequiredElement);
      if (issue?.context) {
        missingRequiredInputNames.push(<string>issue.context);
      }
    });

    if (missingRequiredInputNames.length) {
      this.details.push(
        `<span>The following required parameters must be set:</span><br>
        <strong>${missingRequiredInputNames.join(', ')}</strong>`);
    }
  }

  close() {
    this.dialogRef.close();
  }
}

export interface UserDatasetValidationStateDialogData {
  userDatasetId: number;
  canSeeDetails?: boolean;
}
